module.exports = __webpack_public_path__ + "img/DNARepair-PRCA_10X_AIC.a8ee6d04.png";